<div style="text-align:left">
    @if (field.getUrlFor(focusItem)) {
        <a [routerLink]="field.getUrlFor(focusItem)">{{field.getFormattedValue(focusItem)}}</a>
    } @else {
        <span>{{field.getFormattedValue(focusItem)}}</span>
    }
</div>
